import { observable } from 'mobx';

interface Hoverable {
	[ rootId: string ]: {
		selected: HTMLElement | null;
		oldSelected: HTMLElement | null;
	};
}

interface Data {
	hoverable: Hoverable;
	isSticky: boolean | null;
	hasAdminBar: boolean | null;
	stickyElement: HTMLElement | null;
	isDesktop: boolean | null;
	adminBarHeight: number | null;
	pageTop: number | null;
	heights: Heights;
}

interface Heights {
	header?: number;
	mobileSticky?: number;
	desktopSticky?: number;
}

const data: Data = observable( {
	hoverable: {},
	isSticky: null,
	hasAdminBar: null,
	stickyElement: null,
	isDesktop: null,
	adminBarHeight: null,
	pageTop: null,
	heights: {},
} );

export default data;
